export default {
    loadingMessage: 'Creando autorización...',
    creatingDispensationMessage: "Completando autorización...",
    beneficiaryFieldsStepLabel: 'Datos del beneficiario',
    sponsorFieldsStepLabel: 'Información del médico',
    IdVerificationStepLabel: 'Verificación de identidad',
    billingStepLabel: "Autorización",
    title: {
        text: 'Nueva autorización',
        type: '(Consulta médica)',
        back: 'Cancelar'
    },
    buttons: {
        next: "Continuar",
        back: "Atrás",
        cancel: "Cancelar",
        end: "Finalizar"
    },
    beneficiary: {
        title: 'Identificación de beneficiario',
        description: 'Complete la siguiente información para poder encontrar un beneficiario titular o dependiente',
        sponsor: 'Aseguradora',
        category: 'Categoría',
        search: {
            methodSelection: 'Elige el método de búsqueda para el beneficiario',
            btn: 'Buscar beneficiario'
        }
    },
    sponsors: {
        DO: {
            humano: 'Humano Seguros',
            universal: 'ARS Universal',
            primera: 'ARS Primera',
            humanoCategories: {
                global: "Global",
                platinum: "Platinum",
                conventional: "Convencional"
            }
        },
        GT: {
            umbrella: "Umbrella Osigu ARS"
        }
    },
    header: {
        memberCodeLabel: 'Nº asegurado',
        nameLabel: 'Nombre y apellido',
        identityDocumentNumberLabel: 'Identificación',
        phoneNumberLabel: 'Teléfono',
        emailLabel: 'Email'
    },
    errors: {
        general: "Ocurrió un error en la creación de la autorización",
    }
}
